import React, {useState, useEffect} from 'react'
import {Select} from "antd"
import queryString from "query-string"
import {listPartner} from "../../../../services/api/3dApi"

const {Option} = Select

function BatchesPartner(props) {
    const [partners, setPartners] = useState([])
    const [error, setError] = useState('')

    function _handleChangePartner(name, value) {
        const {onChangePartner} = props

        if (typeof onChangePartner == 'function') {
            onChangePartner(name, value)
        }
    }

    async function _fetchPartners() {
        try {
            const payload = {
                type: 'print_partner'
            }
            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)

            const {success, error, data} = response

            if (!success) {
                return setError(error)
            }

            setError('')
            setPartners(data.partners)
        } catch (e) {
            setError(e.message)
        }
    }

    useEffect(() => {
        _fetchPartners()
        // eslint-disable-next-line
    }, [])

    return (
        <div className='col-12 col-xl-2 mb-3'>
            <label className="font-weight-bold d-block">Đối tác in ép</label>
            <Select
                onChange={(value) => _handleChangePartner('partner', value)}
                defaultValue={''} 
                style={{width: '100%'}}
                dropdownClassName='custom-select-partner'
            >
                <Option value=''>Tất cả</Option>
                {
                    !!partners && partners.length > 0 && partners.map(item => {
                        return <Option key={item._id} value={item.name}>{item.name}</Option>
                    })
                }
            </Select>

            {
                !!error && error.length > 0 && <div className="text-danger">{error}</div>
            }
        </div>
    )
}

export default BatchesPartner
